// extracted by mini-css-extract-plugin
export default {"result-table":"ResultTable_result-table__wwhRn"};